/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { typedDependencies } from './dependenciesTyped.generated.js';
import { createErf } from '../../factoriesAny.js';
export var erfDependencies = {
  typedDependencies,
  createErf
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/esm/entry/dependenciesAny/dependenciesErf.generated.js
// module id = O+A+
// module chunks = 3